import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { formatApiError } from "../lib/api";
import { Eye, EyeSlash } from "@phosphor-icons/react";
import Logo from "../components/Logo";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [name, setName] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== password2) {
      toast.error("Las contraseñas no coinciden");
      return;
    }
    if (password.length < 6) {
      toast.error("La contraseña debe tener al menos 6 caracteres");
      return;
    }
    setLoading(true);
    try {
      await register(email, password, name);
      toast.success("Cuenta creada. Completá tus datos para empezar.");
      navigate("/onboarding", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-app flex items-center justify-center p-4 noise-bg">
      <div className="w-full max-w-md card-base p-8 sm:p-10" data-testid="register-card">
        <div className="flex flex-col items-center text-center gap-3 mb-8">
          <Logo size={110} />
          <div>
            <div className="font-display font-black text-3xl tracking-tighter uppercase leading-tight">Athlon Sports</div>
            <div className="text-xs text-muted uppercase tracking-widest">Training Control</div>
          </div>
        </div>

        <h1 className="font-display uppercase font-black text-4xl tracking-tighter mb-2">Crear Cuenta</h1>
        <p className="text-muted text-sm mb-8">Registrate para acceder a tu perfil</p>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="text-xs uppercase tracking-widest text-muted block mb-2">Nombre completo</label>
            <input value={name} onChange={(e) => setName(e.target.value)} className="input-base" required data-testid="register-name-input" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-muted block mb-2">Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="input-base" required data-testid="register-email-input" autoComplete="email" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-muted block mb-2">Contraseña</label>
            <div className="relative">
              <input
                type={showPwd ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input-base pr-12"
                minLength={6}
                required
                data-testid="register-password-input"
                autoComplete="new-password"
              />
              <button
                type="button"
                onClick={() => setShowPwd(!showPwd)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-muted hover:text-white transition-colors"
                tabIndex={-1}
              >
                {showPwd ? <EyeSlash size={18} weight="bold" /> : <Eye size={18} weight="bold" />}
              </button>
            </div>
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-muted block mb-2">Repetir Contraseña</label>
            <input
              type={showPwd ? "text" : "password"}
              value={password2}
              onChange={(e) => setPassword2(e.target.value)}
              className={`input-base ${password2 && password2 !== password ? "!border-[#FF3B30]" : ""}`}
              minLength={6}
              required
              data-testid="register-password2-input"
              autoComplete="new-password"
            />
            {password2 && password2 !== password && (
              <p className="text-xs text-[#FF3B30] mt-2" data-testid="password-mismatch-error">
                Las contraseñas no coinciden
              </p>
            )}
          </div>
          <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="register-submit-btn">
            {loading ? "Creando..." : "Crear Cuenta"}
          </button>
        </form>

        <p className="text-sm text-muted text-center mt-6">
          ¿Ya tenés cuenta?{" "}
          <Link to="/login" className="text-white hover:text-primary-app font-semibold" data-testid="login-link">
            Ingresá
          </Link>
        </p>
      </div>
    </div>
  );
}
